/**
 *
 * Please note:
 * This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit this file manually.
 *
 */

@file:Suppress(
    "ArrayInDataClass",
    "EnumEntryName",
    "RemoveRedundantQualifierName",
    "UnusedImport"
)

package org.openapitools.client.models

import org.openapitools.client.models.Comment
import org.openapitools.client.models.Pagination

import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

/**
 * 
 *
 * @param `data` 
 * @param pagination 
 */
@Serializable

data class TaskItemComments (

    @SerialName(value = "data") val `data`: MutableList<Comment>? = null,

    @SerialName(value = "pagination") val pagination: Pagination? = null

)

